import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface GenderIconProps {
  size?: number
  color?: string
  title?: string
}

/**
 * MaleGenderIcon renders a male gender SVG with customizable size and color.
 */
const MaleGenderIcon: React.FC<GenderIconProps> = ({
  size = 16,
  color = colors.PRIMARY,
  title,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 -960 960 960'
      fill='none'
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable='false'
    >
      {title ? <title>{title}</title> : null}
      <path
        d='M800-800v240h-80v-103L561-505q19 28 29 59.5t10 65.5q0 92-64 156t-156 64q-92 0-156-64t-64-156q0-92 64-156t156-64q33 0 65 9.5t59 29.5l159-159H560v-80h240ZM380-520q-58 0-99 41t-41 99q0 58 41 99t99 41q58 0 99-41t41-99q0-58-41-99t-99-41Z'
        fill={color}
      />
    </svg>
  )
}

export default MaleGenderIcon
